import { Avatar, Link } from "@heroui/react";
import type { SendReceiveHistoryType, SendReceiveRecord } from "@repo/api";
import { formatTime } from "@repo/utils/tools";
import type { HistoryParty } from "./useSendReceiveHistory";

export type HistoryRecordItemProps = {
  item: SendReceiveRecord;
  type: SendReceiveHistoryType;
  party: HistoryParty;
  onUserPress?: (uid: string) => void;
  onTemplatePress?: (templateId: string, sendId?: string) => void;
  className?: string;
};

export default function HistoryRecordItem({
  item,
  type,
  party,
  onUserPress,
  onTemplatePress,
  className,
}: HistoryRecordItemProps) {
  return (
    <div
      className={`flex gap-3 border-b border-[#f3f3f3] px-4 py-4 last:border-b-0 ${className ?? ""}`}
    >
      <Avatar size="sm" className="size-10 shrink-0">
        <Avatar.Image alt={party.displayName} src={party.avatarUrl} />
        <Avatar.Fallback>{party.displayName.slice(0, 1).toUpperCase()}</Avatar.Fallback>
      </Avatar>
      <div className="min-w-0 flex-1 flex flex-col gap-1.5">
        <p className="text-foreground m-0 text-sm leading-[1.43] wrap-break-word">
          {type === "recive" ? "从 " : "向 "}
          <Link
            className="text-orange-500"
            onPress={() => {
              if (party.partyUid) onUserPress?.(party.partyUid);
            }}
          >
            {party.displayName}
          </Link>
          {type === "recive" ? " 中签收了模板 " : " 发送了模板 "}
          <Link
            className="underline"
            onPress={() => onTemplatePress?.(party.templateId, party.sendId)}
          >
            {item.title}
          </Link>
        </p>
        <p className="text-gray-500 m-0 break-all text-xs">{item.send_id}</p>
        <time className="text-muted text-xs">
          {formatTime(item.received_at, "YYYY-MM-DD HH:mm:ss")}
        </time>
      </div>
    </div>
  );
}
